exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".verification-box {\n  background: #fff;\n  width: 360px;\n  padding: 20px 20px 0px 20px;\n  border-radius: 8px;\n  bottom: 48px;\n  left: 0; }\n  .verification-box .images-box {\n    position: relative;\n    width: 300px;\n    height: 150px;\n    top: 0;\n    left: 0;\n    margin: 0 auto; }\n    .verification-box .images-box .bg-img {\n      width: 300px;\n      height: 150px; }\n    .verification-box .images-box .slider-img {\n      position: absolute;\n      height: 60px;\n      width: 60px;\n      left: 0; }\n  .verification-box .slider-bar > p {\n    text-align: center; }\n  .verification-box .operate i {\n    cursor: pointer;\n    color: #7d7d7d;\n    font-size: 20px;\n    margin-right: 6px;\n    line-height: 30px; }\n\n.block {\n  display: block; }\n\n.hide {\n  display: none; }\n\n.ant-slider-track {\n  height: 6px; }\n\n.ant-slider-handle {\n  width: 20px;\n  height: 20px;\n  margin-top: -8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/login/slider-verification/slider-verification.component.scss
// module id = 1164
// module chunks = 75